(function (root) {
  var SLOT = /^[a-z0-9_]{1,40}$/;
  var STORAGE = 'keyword_copy_key';
  var APPLIED = 'keyword_copy_applied';
  var KEY_LENGTH = 100;
  // Slots of version 2 that steer the page instead of carrying text.
  var STEERING = { hero_media: true, variant: true, reviews_tag: true };
  var MEDIA_GID = /^(?:gid:\/\/shopify\/(?:MediaImage|Video|ExternalVideo|Model3d)\/)?([0-9]{1,20})$/;
  var VARIANT_GID = /^(?:gid:\/\/shopify\/ProductVariant\/)?([0-9]{1,20})$/;
  var TAG = /^[A-Za-z0-9][A-Za-z0-9 _-]{0,63}$/;
  var PENDING = 'data-keyword-copy-pending';
  // What a markup slot may carry: text and its emphasis, paragraphs, lists and breaks, each with a class at most.
  var MARKUP = { P: true, BR: true, STRONG: true, B: true, EM: true, I: true, SPAN: true, UL: true, OL: true, LI: true, SMALL: true, SUB: true, SUP: true };
  // Elements whose content is no text of the page: dropped whole, not unwrapped.
  var DROPPED = { SCRIPT: true, STYLE: true, TEMPLATE: true, IFRAME: true, OBJECT: true, EMBED: true, NOSCRIPT: true, SVG: true, MATH: true, TEXTAREA: true, SELECT: true, TITLE: true, HEAD: true };
  var CLASS = /^[A-Za-z0-9 _-]{0,120}$/;
  var SELECTOR_LENGTH = 200;

  // The same rule as the backend: lower case, ae/oe/ue/ss, everything else becomes a hyphen.
  function normalize(raw) {
    return String(raw || '').toLowerCase()
      .replace(/ä/g, 'ae').replace(/ö/g, 'oe').replace(/ü/g, 'ue').replace(/ß/g, 'ss')
      .replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  }

  // The last kw of the address wins, because a campaign suffix appends the real search term after a fixed one.
  function keywordOf(search) {
    try {
      var all = new root.URLSearchParams(String(search || '')).getAll('kw');
      return all.length ? all[all.length - 1] : '';
    } catch (e) { return ''; }
  }

  // The copy set for a normalized key, directly or through an alias; null without a match.
  function resolve(data, key) {
    var document = data && typeof data === 'object' ? data : {};
    var keywords = document.keywords && typeof document.keywords === 'object' ? document.keywords : {};
    var aliases = document.aliases && typeof document.aliases === 'object' ? document.aliases : {};
    if (!key || !Object.prototype.hasOwnProperty.call) return null;
    var own = Object.prototype.hasOwnProperty;
    var resolved = own.call(keywords, key) ? key : (own.call(aliases, key) && typeof aliases[key] === 'string' && own.call(keywords, aliases[key]) ? aliases[key] : '');
    var copy = resolved ? keywords[resolved] : null;
    return copy && typeof copy === 'object' && !Array.isArray(copy) ? copy : null;
  }

  // Slot and text pairs; markup slots (_html) and anything that is not a string never reach the page.
  function textSlots(copy) {
    var out = [];
    if (!copy || typeof copy !== 'object') return out;
    for (var name in copy) {
      if (!Object.prototype.hasOwnProperty.call(copy, name)) continue;
      if (!SLOT.test(name) || /_html$/.test(name) || Object.prototype.hasOwnProperty.call(STEERING, name) || typeof copy[name] !== 'string' || copy[name].trim() === '') continue;
      out.push([name, copy[name]]);
    }
    return out;
  }

  // Slot and markup pairs: the slots with suffix _html, whose value goes through cleanMarkup before it reaches the page.
  function markupSlots(copy) {
    var out = [];
    if (!copy || typeof copy !== 'object') return out;
    for (var name in copy) {
      if (!Object.prototype.hasOwnProperty.call(copy, name)) continue;
      if (!SLOT.test(name) || !/_html$/.test(name) || typeof copy[name] !== 'string' || copy[name].trim() === '') continue;
      out.push([name, copy[name]]);
    }
    return out;
  }

  // The places a brand names for its slots (keyword_copy.slots in brand.json): slot → [selector, index]. Null without a
  // list, so the [data-copy-slot] elements of the core count; with one, only the slots it names are applied.
  function readSlots(list) {
    if (!list || typeof list !== 'object' || Array.isArray(list)) return null;
    var out = {};
    for (var name in list) {
      if (!Object.prototype.hasOwnProperty.call(list, name) || !SLOT.test(name)) continue;
      var place = list[name];
      var selector = Array.isArray(place) ? place[0] : place;
      var index = Array.isArray(place) && place.length > 1 ? place[1] : 0;
      if (typeof selector !== 'string' || selector === '' || selector.length > SELECTOR_LENGTH) continue;
      if (typeof index !== 'number' || index < 0 || index > 50 || Math.floor(index) !== index) continue;
      out[name] = [selector, index];
    }
    return out;
  }

  // Markup of a slot as a fragment of the target document: parsed inert in a template, then rebuilt from the allowed
  // elements with no attribute but class. An element outside the list leaves its text, a dropped one leaves nothing.
  function cleanMarkup(html, doc) {
    var template = doc.createElement('template');
    template.innerHTML = String(html);
    var out = doc.createDocumentFragment();
    function copyInto(from, to) {
      for (var node = from.firstChild; node; node = node.nextSibling) {
        if (node.nodeType === 3) {
          to.appendChild(doc.createTextNode(node.nodeValue));
          continue;
        }
        if (node.nodeType !== 1) continue;
        var tag = String(node.nodeName).toUpperCase();
        if (Object.prototype.hasOwnProperty.call(DROPPED, tag)) continue;
        if (!Object.prototype.hasOwnProperty.call(MARKUP, tag)) {
          copyInto(node, to);
          continue;
        }
        var element = doc.createElement(tag.toLowerCase());
        var name = node.getAttribute('class');
        if (name && CLASS.test(name)) element.setAttribute('class', name);
        copyInto(node, element);
        to.appendChild(element);
      }
    }
    copyInto(template.content, out);
    return out;
  }

  // Does an experiment gate the copy? With an arm that carries the flag, only that arm sees it.
  function allowed(experiments, assignments) {
    var gated = false;
    var mine = false;
    if (!Array.isArray(experiments)) return true;
    for (var i = 0; i < experiments.length; i++) {
      var experiment = experiments[i] || {};
      var variants = Array.isArray(experiment.variants) ? experiment.variants : [];
      for (var j = 0; j < variants.length; j++) {
        var variant = variants[j] || {};
        if (variant.copy !== true) continue;
        gated = true;
        if (assignments && assignments[experiment.name] === variant.id) mine = true;
      }
    }
    return !gated || mine;
  }

  // The numeric id behind a GID or a bare id; empty when the value is neither.
  function idOf(value, pattern) {
    var match = typeof value === 'string' ? value.trim().match(pattern) : null;
    return match ? match[1] : '';
  }

  // Hero medium, variant and reviews tag of a copy set, each empty when absent or malformed.
  function steering(copy) {
    var set = copy && typeof copy === 'object' ? copy : {};
    var tag = typeof set.reviews_tag === 'string' ? set.reviews_tag.trim() : '';
    return { media: idOf(set.hero_media, MEDIA_GID), variant: idOf(set.variant, VARIANT_GID), reviewsTag: TAG.test(tag) ? tag : '' };
  }

  // Cart attributes that differ from the keyword of the session; an empty patch means nothing to write.
  function attributePatch(current, key, applied) {
    var attributes = current && typeof current === 'object' ? current : {};
    var wanted = { _kw: String(key || '').slice(0, KEY_LENGTH), _kw_copy: applied ? '1' : '0' };
    var patch = {};
    if (wanted._kw === '') return patch;
    for (var name in wanted) {
      if (attributes[name] !== wanted[name]) patch[name] = wanted[name];
    }
    return patch;
  }

  var api = { normalize: normalize, keywordOf: keywordOf, resolve: resolve, textSlots: textSlots, markupSlots: markupSlots, readSlots: readSlots, cleanMarkup: cleanMarkup, allowed: allowed, steering: steering, attributePatch: attributePatch };
  root.themeKeywordCopy = api;
  if (!root.document) return;

  var document = root.document;
  var data = null;
  try { data = JSON.parse(document.querySelector('script[data-keyword-copy]').textContent); } catch (e) { data = null; }
  var places = null;
  try { places = readSlots(JSON.parse(document.querySelector('script[data-keyword-copy-slots]').textContent)); } catch (e) { places = null; }
  // The head hides title, claim and benefits while a copy set waits (snippet keyword-copy); whatever happens, they come back.
  function lift() {
    if (document.documentElement && document.documentElement.removeAttribute) document.documentElement.removeAttribute(PENDING);
  }

  var raw = keywordOf(root.location.search);
  var key = normalize(raw);
  try {
    if (key) root.sessionStorage.setItem(STORAGE, key);
    else key = normalize(root.sessionStorage.getItem(STORAGE));
  } catch (e) {}
  if (!key) {
    lift();
    return;
  }

  var copy = resolve(data, key);
  if (copy) {
    var experiments = [];
    try { experiments = JSON.parse(document.querySelector('script[data-experiments]').textContent); } catch (e) { experiments = []; }
    var assignments = root.themeExperiments ? root.themeExperiments.assignments(document.documentElement.attributes) : {};
    if (!allowed(experiments, assignments)) copy = null;
  }

  // Once applied in this session, the order counts as one with copy, even when the cart changes on another page.
  var applied = false;
  try {
    if (copy) root.sessionStorage.setItem(APPLIED, key);
    applied = root.sessionStorage.getItem(APPLIED) === key;
  } catch (e) { applied = !!copy; }

  // The order carries the keyword: written once, on the first cart change of the page, like the experiment arms.
  var updateUrl = document.body && document.body.dataset ? document.body.dataset.cartUpdateUrl : '';
  if (typeof root.fetch === 'function' && typeof document.addEventListener === 'function' && updateUrl) {
    var synced = false;
    document.addEventListener('cart:updated', function (event) {
      var cart = event && event.detail && event.detail.cart;
      if (synced || !cart) return;
      var patch = attributePatch(cart.attributes, key, applied);
      synced = true;
      if (Object.keys(patch).length === 0) return;
      root.fetch(updateUrl + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes: patch }),
      }).catch(function () { synced = false; });
    });
  }

  if (!copy) {
    lift();
    return;
  }
  var slots = textSlots(copy);
  var markup = markupSlots(copy);
  var steer = steering(copy);

  // The element of a slot: where the brand names it, else the core's [data-copy-slot]; a brand list is the whole list.
  function slotElement(name) {
    if (places === null) return document.querySelector('[data-copy-slot="' + name + '"]');
    if (!Object.prototype.hasOwnProperty.call(places, name)) return null;
    try {
      return document.querySelectorAll(places[name][0])[places[name][1]] || null;
    } catch (e) {
      return null;
    }
  }

  // The medium of the group moves to the front of the gallery and its strip, so it stands where the lead picture stood.
  function showHero() {
    var gallery = document.querySelector('product-gallery');
    var track = gallery && gallery.querySelector('[data-track]');
    var item = track && track.querySelector('[data-media-id="' + steer.media + '"]');
    if (!item) return;
    if (item !== track.firstElementChild) track.insertBefore(item, track.firstElementChild);
    var image = item.querySelector('img');
    if (image) image.loading = 'eager';
    var thumbnail = gallery.querySelector('[data-thumbnail="' + steer.media + '"]');
    var row = thumbnail && thumbnail.closest('li');
    if (row && row.parentNode && row !== row.parentNode.firstElementChild) row.parentNode.insertBefore(row, row.parentNode.firstElementChild);
    var current = gallery.querySelectorAll('[data-thumbnail]');
    for (var i = 0; i < current.length; i++) {
      if (current[i] === thumbnail) current[i].setAttribute('aria-current', 'true');
      else current[i].removeAttribute('aria-current');
    }
    track.scrollLeft = 0;
  }

  // The variant is chosen through the picker of the buy box, which reloads the box and announces variant:changed; an explicit ?variant= wins.
  function chooseVariant() {
    var params = null;
    try { params = new root.URLSearchParams(String(root.location.search || '')); } catch (e) { return; }
    if (params.get('variant')) return;
    var input = document.querySelector('variant-picker input[name="variant"][value="' + steer.variant + '"]');
    if (!input || input.checked || input.disabled || input.getAttribute('data-available') !== 'true') return;
    if (steer.media) {
      document.addEventListener('variant:changed', function keepHero() {
        document.removeEventListener('variant:changed', keepHero);
        root.setTimeout(showHero, 0);
      });
    }
    input.checked = true;
    input.dispatchEvent(new root.Event('change', { bubbles: true }));
  }

  // GAP: Der Bewertungsblock trägt den Filter nur als Attribut; welches Reviews.io-Widget ihn liest, ist im Kern noch nicht angedockt.
  function tagReviews() {
    var blocks = document.querySelectorAll('[data-reviews]');
    for (var i = 0; i < blocks.length; i++) blocks[i].setAttribute('data-reviews-tag', steer.reviewsTag);
  }

  // A slot is written once; the sections below the buy box may stand only after the first pass.
  var done = {};
  function apply() {
    for (var i = 0; i < slots.length; i++) {
      if (done[slots[i][0]]) continue;
      var element = slotElement(slots[i][0]);
      if (!element) continue;
      element.textContent = slots[i][1];
      done[slots[i][0]] = true;
    }
    // Markup slots only where a brand names their place: the core has no element that takes markup.
    for (var j = 0; places !== null && j < markup.length; j++) {
      if (done[markup[j][0]]) continue;
      var target = slotElement(markup[j][0]);
      if (!target) continue;
      while (target.firstChild) target.removeChild(target.firstChild);
      target.appendChild(cleanMarkup(markup[j][1], document));
      done[markup[j][0]] = true;
    }
    lift();
  }
  function steerOnce() {
    if (steer.media) showHero();
    if (steer.reviewsTag) tagReviews();
    if (steer.variant && root.customElements) root.customElements.whenDefined('variant-picker').then(chooseVariant);
  }
  function start() {
    apply();
    steerOnce();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  if (typeof root.addEventListener === 'function') root.addEventListener('load', apply);
})(window);
